import {
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonToggle
} from "@ionic/react";
import {
  CAPACITY_REMOVED,
  NO_TRUCKS_MESSAGE,
  PAGE_TITLES
} from "./../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import React, { useEffect, useState } from "react";

import "./ManageCapacity.scss";
import { ToastMessage } from "../../../utils/ToastMessage";
import { CapacityModel } from "../../../models/manage/capacity.model";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { R2Configuration } from "../../../utils/common";
import { ICapacity } from "../../../schemas/manage/manage.Schema";
import { capitalize } from "../../../utils/helper";
import { EmptyListComponent } from "../../../components/EmptyListComponent";
import { ManageCapacityCard } from "./ManageCapacityCard";
import { ManageCapacityHeader } from "../../components/manage-capacity/ManageCapacityHeader";

const ManageCapacityPage = (props: any) => {
  const {
    capacityList,
    userDetails,
    isNetWorkAvailable,
    showNetworkAlert,
    history,
    removeCapacityAction,
    onShowMore,
    addCapacityItem,
    isCapacityEnd,
    onTabChange,
    remainingLoads
  } = props;
  const [selectedSegment, setSelectedSegment] = useState<string>("ALL");
  const [showCapacitiesWithResults, setShowCapacitiesWithResults] = useState<
    boolean
  >(false);
  const capacityModel = new CapacityModel();

  useEffect(() => {
    // Analytics implementation
    setScreenName("screen_manage_my_capacity");
    logEvent(EVENT.SV_MANAGE_CAPACITY, {
      screen: SCREEN.MANAGE_CAPACITY,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId
    });
    let selectedsegment = props?.ManageSegmentSelected;
    
    if (selectedsegment) {
      setSelectedSegment(selectedsegment);
      props.setManageSegmentSelected("ALL");
    }
  }, []);
  useEffect(() => {
    const _filter = history.location?.state?.filter?.trim().toUpperCase();
    if (_filter && capacityList.length > 0) {
      if (_filter.includes("TRUCK")) {
        setSelectedSegment("TRUCK")
      } else if (_filter.includes("LANE")) {
        setSelectedSegment("LANE")
      } else {
        setSelectedSegment("ALL")
      }
      history.replace({ ...history.location, state: {} });
      props.clearDynamicLinkParams && props.clearDynamicLinkParams();
    }
  }, [history.location && history.location.state,capacityList])

  const addPage = () => {
    if (R2Configuration.details.getR2FeatureEnable()) {
      ToastMessage.show();
      return;
    }
    if (!isNetWorkAvailable) {
      showNetworkAlert();
      return;
    }
    history.push(`/app/manage-capacity/add`);
  };

  useEffect(()=> {
    onTabChange(selectedSegment);
  },[selectedSegment]);

  const undoCapacity = (capacity: ICapacity) => {
    const destination = capacity.destination
      ? {
          destinationCity: capacity.destination.city,
          destinationState: capacity.destination.state,
          destinationCountry: capacity.destination.country,
          destinationLatitude: capacity.destination.latitude,
          destinationLongitude: capacity.destination.longitude,
          destinationRadius: capacity.destination.radius
        }
      : {};

    const origin = capacity.origin
      ? {
          originCity: capacity.origin.city,
          originState: capacity.origin.state,
          originRadius: capacity.origin.radius,
          originCountry: capacity.origin.country,
          originLongitude: capacity.origin.latitude,
          originLatitude: capacity.origin.longitude
        }
      : {};
    const input = {
      capacityId: null,
      userId: capacity.lastUpdatedBy,
      upn:userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
      userEmail: capacity.lastUpdatedByEmail,
      userPhone: capacity.lastUpdatedByPhoneNumber,
      capacityType: capacity.capacityType,
      commonCarrierId: capacity.commonCarrierId,
      trailerType: capacity.trailerType,
      ...origin,
      ...destination,
      preferredDays: capacity.preferredDays,
      pickUpToDate: capacity.pickUpToDate,
      pickUpFromDate: capacity.pickUpFromDate,
      destinationStates: capacity.destinationStates
    };
    const query = capacityModel.addCapacity();
    addCapacityItem({ params: { query, input }, callback: () => {} });
  };

  const handleDelete = (capacity: ICapacity) => {
    const { capacityId, capacityType } = capacity;
    const type: any = capacityType;
    if (!isNetWorkAvailable) {
      showNetworkAlert();
      return;
    }
    const query = capacityModel.deleteCapacity(capacityId);
    const callback = () => {
      ToastMessage.open({
        showUndo: true,
        message: CAPACITY_REMOVED.replace(
          "{{CAPACITY}}",
          capitalize(type, true)
        ),
        callback: () => {
          undoCapacity(capacity);
        }
      });
    };
    removeCapacityAction({ query, capacityId, callback });
  };

  const handleViewClick = (capacity: ICapacity) => {
    const { capacityId } = capacity;
    if (!isNetWorkAvailable) {
      showNetworkAlert();
      return;
    }
    props.setSelectedCapacityAction({ capacityItem: capacity });
    props.setManageSegmentSelected(selectedSegment);
    history.push(`/app/manage-capacity/view/${capacityId}`);   
  };
  const navigateToAdCapacityPage = () => {
    history.push("/app/manage-capacity/add");
  };
  const isCapacityListItemsWithLoadCount: boolean = isCapacityEnd && capacityList.some(
    ({ loadCount }:any) => loadCount > 0 ) || false;
  const showCapacitiesWithResultsChecked =
    isCapacityListItemsWithLoadCount && showCapacitiesWithResults;

  return (
    <IonPage className="myloads-page manage-capacity">
      <ManageCapacityHeader
        title={PAGE_TITLES.MANAGE_CAPACITY}
        actionName="Add New Capacity"
        actionClick={navigateToAdCapacityPage}
        iconSrc="assets/icon/plus-icon.svg"
        segmentselected ={selectedSegment}
      />
      <IonGrid className="header">
        <IonRow>
          <IonCol size="8">
            <IonSegment
              className="segment"
              onIonChange={(e: any) => {
                setSelectedSegment(e.detail.value);
              }}
              value={selectedSegment}
            >
              <IonSegmentButton value="ALL">
                <IonLabel>All</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="TRUCK">
                <IonLabel>Trucks</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="LANE">
                <IonLabel>Lanes</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </IonCol>
          <IonCol size="4" className={`capacity-action-col`}>
            <IonToggle
              checked={showCapacitiesWithResultsChecked}
              className="tgl-capacity-result"
              mode="ios"
              onIonChange={() => {
                setShowCapacitiesWithResults(
                  (prevValue: boolean) => !prevValue
                );
              }}
              disabled={!isCapacityListItemsWithLoadCount}
            />
            <IonLabel className="lbl-show-capacity-result">
              Show only capacities with results
            </IonLabel>
          </IonCol>
        </IonRow>
      </IonGrid>
      <IonGrid class="manage-capacity-list">
        {capacityList.length > 0 ? (
          <>
            {capacityList.map((listItem: any, index: number) => {
              if (showCapacitiesWithResultsChecked) {
                return listItem.loadCount > 0 ? (
                  <ManageCapacityCard
                    data={listItem}
                    key={`lane${index}`}
                    handleDelete={handleDelete}
                    handleViewClick={handleViewClick}
                    userDetails={userDetails}
                    segmentselected ={selectedSegment}
                  />
                ) : null;
              } else {
                return (
                  <ManageCapacityCard
                    data={listItem}
                    key={`lane${index}`}
                    handleDelete={handleDelete}
                    handleViewClick={handleViewClick}
                    userDetails={userDetails}
                    segmentselected ={selectedSegment}
                  />
                );
              }
            })}
          </>
        ) : (
          <EmptyListComponent
            icon="no-search-icon"
            message={NO_TRUCKS_MESSAGE}
            callback={addPage}
            constantButton={"Add"}
          />
        )}
      </IonGrid>
        <IonCol size="12">
          {capacityList.length > 0 && isCapacityEnd ? (
            <div className={"list-end-banner"}>
              <div className={"end-list"}>
                <div className="left"></div>
                <div className="center">End of List</div>
                <div className="right"></div>
              </div>
            </div>
          ) : (capacityList.length > 0) ? (
            <IonButton className="btn-common-web" onClick={onShowMore}>
              Show {remainingLoads} More
            </IonButton>
          ):null}
        </IonCol>
    </IonPage>
  );
};

export default ManageCapacityPage;
